import React from "react";
import PropTypes from "prop-types";
import { Field, ErrorMessage, useFormikContext } from "formik";

import { states } from "../states";
import classNames from "classnames";

const DateField = ({ item, compositeIndex, compositeParent }) => {
  const { values, handleBlur, handleChange } = useFormikContext();

  const { invisible, visible, enabled, disabled, optional, required } = states(
    item.states,
    values
  );

  return (
    <div
      className={classNames({
        "form-group": true,
        hidden: invisible || !visible,
      })}
      style={item.flex ? { flex: item.flex } : {}}
    >
      <label htmlFor={item.id}>
        {item.title}
        {(!!item.required || required) && !optional && visible && (
          <span className="required">*</span>
        )}
      </label>

      <Field
        id={
          compositeParent
            ? `${compositeParent}[${compositeIndex}][${item.id}]`
            : item.id
        }
        name={
          compositeParent
            ? `${compositeParent}[${compositeIndex}][${item.id}]`
            : item.id
        }
        min={item.dateMin}
        max={item.dateMax}
        type="date"
        className="form-control"
        onChange={handleChange}
        onBlur={handleBlur}
        value={
          compositeParent
            ? values[compositeParent][compositeIndex][item.id]
            : values[item.id]
        }
        required={(!!item.required || required) && !optional && visible}
        disabled={!enabled || disabled}
      />

      <ErrorMessage
        role="region"
        aria-live="polite"
        component="span"
        name={item.id}
        className="error-message"
      />
      {!!item.description && (
        <small className="form-description text-muted form-text">
          {item.description}
        </small>
      )}
    </div>
  );
};

DateField.propTypes = {
  item: PropTypes.shape({
    description: PropTypes.string,
    flex: PropTypes.string,
    id: PropTypes.string,
    states: PropTypes.object,
    required: PropTypes.object,
    title: PropTypes.string,
    dateMin: PropTypes.string,
    dateMax: PropTypes.string,
  }),
  compositeIndex: PropTypes.number,
  compositeParent: PropTypes.string,
};

export default DateField;
